export const EMBLEM_CATEGORIES = [
    "general",
    "seasonal", 
    "account",            
    "competitive",  
    "gambit",       
    "strikes",      
    "open world",        
    "trials of osiris",       
    "raids",        
    // "custom"        
]

export const EMBLEM_RARITIES = [
    "common", 
    "uncommon", 
    "rare",
    "legendary", 
    "exotic"
]

export const EMBLEM_TYPES = [
    "destiny 2", 
    // "destiny 1", 
    // "custom"
]

export const PLAY_DESKTOP_ANIMATIONS_ONE = {
    "ENTRANCE": "animate-slideInLeft",
    "SELECTED": "animate-flash",
    "EXIT": "animate-slideOutLeft",
    "IDLE": ""
}

export const PLAY_DESKTOP_ANIMATIONS_TWO = {
    "ENTRANCE": "animate-slideInRight",
    "SELECTED": "animate-flash",
    "EXIT": "animate-slideOutRight",
    "IDLE": ""
}

export const PLAY_MOBILE_ANIMATIONS_ONE = {
    "ENTRANCE": "animate-slideInRight",
    "SELECTED": "animate-flash",
    "EXIT": "animate-slideOutLeft",
    "IDLE": ""
}

export const PLAY_MOBILE_ANIMATIONS_TWO = {
    "ENTRANCE": "animate-slideInLeft",
    "SELECTED": "animate-flash",
    "EXIT": "animate-slideOutRight",
    "IDLE": ""
}

// make medal names lowercase in frontend and backend
export const MEDALS_CONFIG = {
    "CONTEST": {
        medalOptions: {
            desc: "have voted on any round within 48 hours of itsfinal going live",
            txtColour: "text-contest",
            bgColour: "bg-contest",
            req: 1
        },
        tagOptions: {
            bgColour: "bg-contest/10",
            bdrColour: "border-contest/10",
            txtColour: "text-contest"
        }
    },
    "FLAWLESS": {
        medalOptions: {
            desc: "have obtained a streak of 30 by voting everyday for 30 days",
            txtColour: "text-flawless",
            bgColour: "bg-flawless",
            req: 30
        },
        tagOptions: {
            bgColour: "bg-flawless/10",
            bdrColour: "border-flawless/10",
            txtColour: "text-flawless"
        }
    },
    "ALWAYS ON TIME": {
        medalOptions: {
            desc: "for each round of a tournament, have voted within 5 minutes of the round starting",
            txtColour: "text-always-on-time",
            bgColour: "bg-always-on-time",
            req: 3
        },
        tagOptions: {
            bgColour: "bg-always-on-time/10",
            bdrColour: "border-always-on-time/10",
            txtColour: "text-always-on-time"
        }
    },
    "WARMIND": {
        medalOptions: {
            desc: "have voted a total of 50 times",
            txtColour: "text-warmind",
            bgColour: "bg-warmind",
            req: 50
        },
        tagOptions: {
            bgColour: "bg-warmind/10",
            bdrColour: "border-warmind/10",
            txtColour: "text-warmind"
        }
    },
    "FINAL STAND": {
        medalOptions: {
            desc: "on round 3 of any tournament, have voted 5 minutes before the round closes",
            txtColour: "text-final-stand",
            bgColour: "bg-final-stand",
            req: 1
        },
        tagOptions: {
            bgColour: "bg-final-stand/10",
            bdrColour: "border-final-stand/10",
            txtColour: "text-final-stand"
        }
    },
    "TELESTO": {
        medalOptions: {
            desc: "[REDACTED]",
            txtColour: "text-telesto",
            bgColour: "bg-telesto",
            req: 7
        },
        tagOptions: {
            bgColour: "bg-telesto/10",
            bdrColour: "border-telesto/10",
            txtColour: "text-telesto"
        }
    },
    "TRAVELER'S CHOSEN": {
        medalOptions: {
            desc: "have received a tournament giveaway emblem",
            txtColour: "text-travelers-chosen",
            bgColour: "bg-travelers-chosen",
            req: 1
        },
        tagOptions: {
            bgColour: "bg-travelers-chosen/10",
            bdrColour: "border-travelers-chosen/10",
            txtColour: "text-travelers-chosen"
        }
    },
    "YOUNG WOLF": {
        medalOptions: {
            desc: "have voted a total of 10 times",
            txtColour: "text-young-wolf",
            bgColour: "bg-young-wolf",
            req: 10
        },
        tagOptions: {
            bgColour: "bg-young-wolf/10",
            bdrColour: "border-young-wolf/10",
            txtColour: "text-young-wolf"
        }
    },
    "EYES UP GUARDIAN": {
        medalOptions: {
            desc: "have created an itsfinal account",
            txtColour: "text-eyes-up-guardian",
            bgColour: "bg-eyes-up-guardian",
            req: 1
        },
        tagOptions: {
            bgColour: "bg-eyes-up-guardian/10",
            bdrColour: "border-eyes-up-guardian/10",
            txtColour: "text-eyes-up-guardian"
        }
    },
    "RECONSTRUCTION": {
        medalOptions: {
            desc: "have built 25 emblems using the emblem builder",
            txtColour: "text-reconstruction",
            bgColour: "bg-reconstruction",
            req: 25
        },
        tagOptions: {
            bgColour: "bg-reconstruction/10",
            bdrColour: "border-reconstruction/10",
            txtColour: "text-reconstruction"
        }
    },
    "ACQUISITION": {
        medalOptions: {
            desc: "have unlocked any 7 medals",
            txtColour: "text-acquisition",
            bgColour: "bg-acquisition",
            req: 7
        },
        tagOptions: {
            bgColour: "bg-acquisition/10",
            bdrColour: "border-acquisition/10",
            txtColour: "text-acquisition"
        }
    },
    "THE LAST WORD": {
        medalOptions: {
            desc: "have voted on round 3 of 5 tournaments",
            txtColour: "text-the-last-word",
            bgColour: "bg-the-last-word",
            req: 5
        },
        tagOptions: {
            bgColour: "bg-the-last-word/10",
            bdrColour: "border-the-last-word/10",
            txtColour: "text-the-last-word"
        }
    },
    "ARCHITECT": {
        medalOptions: {
            desc: "have helped develop itsfinal",
            txtColour: "text-architect",
            bgColour: "bg-architect",
            req: 1
        },
        tagOptions: {
            bgColour: "bg-architect/10",
            bdrColour: "border-architect/10",
            txtColour: "text-architect"
        }
    },
    "FIRST WAVE": {
        medalOptions: {
            desc: "have participated in the itsfinal beta",
            txtColour: "text-first-wave",
            bgColour: "bg-first-wave",
            req: 1
        },
        tagOptions: {
            bgColour: "bg-first-wave/10",
            bdrColour: "border-first-wave/10",
            txtColour: "text-first-wave"
        }
    },
    "DISCIPLE": {
        medalOptions: {
            desc: "have donated to itsfinal",
            txtColour: "text-disciple",
            bgColour: "bg-disciple",
            req: 1
        },
        tagOptions: {
            bgColour: "bg-disciple/10",
            bdrColour: "border-disciple/10",
            txtColour: "text-disciple"
        }
    },
    // "AGENT OF THE NINE": {
    //     // EMBLEM CODE DONATIONS
    // }
    // "GAME2GIVE 25": {
    //     // FOR GAME2GIVE 2025
    // }
}

export const RARITIES_CONFIG = {
    "common": {
        tagOptions: {
            bgColour: "bg-common/10",
            bdrColour: "border-common/10",
            txtColour: "text-common"
        }
    },
    "uncommon": {
        tagOptions: {
            bgColour: "bg-uncommon/10",
            bdrColour: "border-uncommon/10",
            txtColour: "text-uncommon"
        }
    },
    "rare": {
        tagOptions: {
            bgColour: "bg-rare/10",
            bdrColour: "border-rare/10",
            txtColour: "text-rare"
        }
    },
    "legendary": {
        tagOptions: {
            bgColour: "bg-legendary/10",
            bdrColour: "border-legendary/10",
            txtColour: "text-legendary"
        }
    },
    "exotic": {
        tagOptions: {
            bgColour: "bg-exotic/10",
            bdrColour: "border-exotic/10",
            txtColour: "text-exotic"
        }
    }
}

export const CATEGORIES_CONFIG = {
    "account": {
        tagOptions: {
            bgColour: "bg-account/10",
            bdrColour: "border-account/10",
            txtColour: "text-account"
        }
    },
    "seasonal": {
        tagOptions: {
            bgColour: "bg-seasonal/10",
            bdrColour: "border-seasonal/10",
            txtColour: "text-seasonal"
        }
    },
    "general": {
        tagOptions: {
            bgColour: "bg-general/10",
            bdrColour: "border-general/10",
            txtColour: "text-general"
        }
    },
    "competitive": {
        tagOptions: {
            bgColour: "bg-competitive/10",
            bdrColour: "border-competitive/10",
            txtColour: "text-competitive"
        }
    },
    "gambit": {
        tagOptions: {
            bgColour: "bg-gambit/10",
            bdrColour: "border-gambit/10",
            txtColour: "text-gambit"
        }
    },
    "strikes": {
        tagOptions: {
            bgColour: "bg-strikes/10",
            bdrColour: "border-strikes/10",
            txtColour: "text-strikes"
        }
    },
    "trials of osiris": {
        tagOptions: {
            bgColour: "bg-trials/10",
            bdrColour: "border-trials/10",
            txtColour: "text-trials"
        }
    },
    "open world": {
        tagOptions: {
            bgColour: "bg-world/10",
            bdrColour: "border-world/10",
            txtColour: "text-world"
        }
    },
    "raids": {
        tagOptions: {
            bgColour: "bg-raids/10",
            bdrColour: "border-raids/10",
            txtColour: "text-raids"
        }
    },
    "custom": {
        tagOptions: {
            bgColour: "bg-custom/10",
            bdrColour: "border-custom/10",
            txtColour: "text-custom"
        }
    },
}

export const FAQS = {
    "tournaments": [
        {
            question: "how long does a tournament last?",
            answer: "All tournaments last for a total of 3 days or 72 hours. With each of the 3 rounds lasting for 24 hours."
        },
        {
            question: "what's the countdown next to the current tournament?",
            answer: "The countdown indicates how much time is left to vote on the current round."
        },
        {
            question: "what time does the next round start?",
            answer: "Tournament rounds are scheduled to start at 5:00pm UTC, the same time as Destiny reset."
        }
    ],
    "voting": [
        {
            question: "how many times can i vote?",
            answer: "You can vote once per round or every 24 hours."
        },
        {
            question: "why did my vote fail?",
            answer: "Voting too close to the next round may result in your vote failing, as the next round may have already began by the time the vote is recieved."
        },
        {
            question: "the server is down and i cannot vote, what happens to my streak?",
            answer: "Don't worry! ITSFINAL has something called the SYNC ALGORITHM which will detect any missed rounds due to server downtime and will add blank votes to your account to your maintain streaks."
        }
    ],
    "medals": [
        {
            question: "what are medals and how do i earn them?",
            answer: "Medals are ITSFINAL's achievement system. They are like Destiny triumphs and titles combined. Medals can be earned by completeting certain objectives. For example, the YOUNG WOLF medals requires you to vote 10 times and the RECONSTRUCTION medal requires you to build 25 emblems."
        },
        {
            question: "why is x medal is not showing on my profile?",
            answer: "Depending on the medal you may need to vote one more time or build another emblem for the medal to synchronise with your account. For example, the ACQUISITION medal is unable to track medals when voting."
        },
        {
            question: "how can i earn the DISCIPLE medal?",
            answer: "The DISCIPLE medal can be earned by donating to ITSFINAL via one of the donation links. Please refer to the donations section on this page for more detail."
        }
    ],
    "streaks": [
        {
            question: "what do current and longest streak mean?",
            answer: "Your current streak tracks how many days in a row you have voted. For example, if you vote everyday for 7 days, then your current streak would be 7. Your longest streak tracks your highest obtained current streak."
        },
        {
            question: "why has my streak reset?",
            answer: "Missing voting on any round will reset your streak, so be sure to come back each round!"
        },
        {
            question: "what do i get for having a high streak?",
            answer: "Certain medals require obtaining a certain streak. For example, the FLAWLESS medal requires a streak of 30. Addtionally, in the future a leaderboards system will be added to ITSFINAL, so if you want to be at the top a high streak will certainly help."
        },
    ],
    "giveaways": [
        {
            question: "how do i win a giveaway?",
            answer: "Tournaments may include a giveaway emblem that can be won. To have a chance at winning the emblem all you have to do is vote on all 3 rounds of the same tournament."
        },
        {
            question: "how do i know if i have won a giveaway?",
            answer: "The code will appear in your postmaster located on your guardians page, so be sure to check it after each tournament concludes."
        },
        {
            question: "are the emblem codes real?",
            answer: "Yes. All emblem giveaways use official Destiny 2 emblems obtained directly from the Bungie store."
        },
        {
            question: "the emblem code does not work?",
            answer: "In the case the code does not work, it may have been mistyped. To resolve this please reach out on the ITSFINAL Discord server."
        }
    ], 
    "donations": [
        {
            question: "how do i donate?",
            answer: "You can donate by clicking on any of the donate links, like the one located in the footer at the bottom of the page. Thank you for the support!"
        },
        {
            question: "how does my donation help?",
            answer: "All donations go directly towards the hosting costs of the site and future projects."
        },
        {
            question: "how will i recieve the disciple medal when i donate?",
            answer: "When donating be sure to comment your username as the donations page will be checked reguarly. The DISCIPLE medal should appear on your profile within 48hrs, otherwise please reach out on the ITSFINAL Discord server."
        },
    ],
    "misc": [
        {
            question: "are you the creator of symboltracker.net?",
            answer: "Yes. Enjoy the red borders!"
        },
        {
            question: "how can i stay up-to-date?",
            answer: "I highly suggest joining the ITSFINAL Discord server by clicking on the Discord icon at the bottom of the page or one of the banners located around the site. "
        },
        {
            question: "how can i delete my account?",
            answer: "Navigate to itsfinal.net/delete-account"
        },
        {
            question: "what class do i main?",
            answer: "Titan!"
        },
        {
            question: "unknown transmission",
            answer: "54454c4553544f20495320434f4d494e47"
        },
    ]
}

export const PAGE_LAYOUT_CONFIG = [
    {
        pathName: "/",
        renderHeader: {
            desktop: true,
            mobile: true
        },
        renderFooter: {
            desktop: true,
            mobile: true
        }
    },
    {
        pathName: "/builder",
        renderHeader: {
            desktop: true,
            mobile: true
        },
        renderFooter: {
            desktop: false,
            mobile: false
        }
    },
    {
        pathName: "/profile",
        renderHeader: {
            desktop: true,
            mobile: true
        },
        renderFooter: {
            desktop: true,
            mobile: true
        }
    },
    {
        pathName: "/auth",
        renderHeader: {
            desktop: false,
            mobile: false
        },
        renderFooter: {
            desktop: false,
            mobile: false
        }
    },
    {
        pathName: "/play",
        renderHeader: {
            desktop: false,
            mobile: false
        },
        renderFooter: {
            desktop: false,
            mobile: false
        }
    },
    {
        pathName: "/privacy",
        renderHeader: {
            desktop: true,
            mobile: true
        },
        renderFooter: {
            desktop: true,
            mobile: true
        }
    },
    {
        pathName: "/faq",
        renderHeader: {
            desktop: true,
            mobile: true
        },
        renderFooter: {
            desktop: true,
            mobile: true
        }
    },
    {
        pathName: "/creator",
        renderHeader: {
            desktop: true,
            mobile: true
        },
        renderFooter: {
            desktop: false,
            mobile: false
        }
    },
    {
        pathName: "/delete-account",
        renderHeader: {
            desktop: false,
            mobile: false
        },
        renderFooter: {
            desktop: false,
            mobile: false
        }
    },
    {
        pathName: "/donations",
        renderHeader: {
            desktop: true,
            mobile: true
        },
        renderFooter: {
            desktop: true,
            mobile: true
        }
    },
    // {
    //     pathName: "/game2give",
    //     renderHeader: {
    //         desktop: true,
    //         mobile: true
    //     },
    //     renderFooter: {
    //         desktop: true,
    //         mobile: true
    //     }
    // }
    {
        pathName: "/test",
        renderHeader: {
            mobile: false,
            desktop: false
        },
        renderFooter: {
            mobile: false,
            desktop: false
        }
    }
]

export const VIEWPORT_BREAKPOINTS = {
    MOBILE: 768,
    DESKTOP_HD: 1920,
    DESKTOP_2K: 2560,
    DESKTOP_4K: 3840,
}

export const REACT_SWIPEABLE_CONFIG = {
    delta: 75,
    trackTouch: true,
    trackMouse: false
}

export const INITIAL_TOURNAMENT_CREATOR_STATE = {
    dateStart: "",
    contestants: [],
    giveaway: null
}

export const DEFAULT_EMBLEM = {
    _id: "1940590816",
    name: "The First Wave",
    category: "account",
    rarity: "common",
    source: "destiny 2",
    urls: {
        icon: "https://www.bungie.net/common/destiny2_content/icons/a7286c31f65636ecdc8745a856988509.jpg",
        secondaryOverlay: "https://www.bungie.net/common/destiny2_content/icons/fbd2eaf6680960a05fee25fb0c8d9b98.png",
        secondaryIcon: "https://www.bungie.net/common/destiny2_content/icons/e7b826767f7ba6693d6fc9846b9c073c.jpg",
        secondarySpecial: "https://www.bungie.net/common/destiny2_content/icons/f7f5e8bf1f3fd42e017869f71bf9c949.jpg",
        secondaryIconCustom: "https://www.bungie.net/common/destiny2_content/icons/e7b826767f7ba6693d6fc9846b9c073c.jpg"
    }
}

export const DEFAULT_PROPERTIES = {
    saturation: "default",
    contrast: "default",
    brightness: "default",
    hue: "default",
    transform: {
        vertical: false,
        horizontal: false
    },
    filter: {
        invert: false,
        grayscale: false
    }
}

export const INITIAL_EMBLEM_BUILDER_STATE = {
    background: {
        emblem: DEFAULT_EMBLEM,
        properties: {
            ...DEFAULT_PROPERTIES
        }
    },
    icon: {
        emblem: DEFAULT_EMBLEM,
        properties: {
            ...DEFAULT_PROPERTIES
        }
    }
}

export const PROPERTY_CLASSES = {
    saturation: {
        low: "saturate-[0.5]",
        default: "saturate-[1.0]",
        medium: "saturate-[1.5]",
        high: "saturate-[2.0]"
    },
    contrast: {
        low: "contrast-[0.75]",
        default: "contrast-[1.0]",
        medium: "contrast-[1.5]",
        high: "contrast-[2.0]"
    },
    brightness: {
        low: "brightness-[0.5]",
        default: "brightness-[1.0]",
        medium: "brightness-[1.5]",
        high: "brightness-[2.0]"
    },
    hue: {
        low: "hue-rotate-[90deg]",
        default: "hue-rotate-[0deg]",
        medium: "hue-rotate-[180deg]",
        high: "hue-rotate-[270deg]"
    }
}

export const OS_OPTIONS = {
    scrollbars: {
        theme: "os-theme-custom"
    }
}

export const FORM_BUTTON_STYLES_ADD = {
    base: "bg-epic-blue border-epic-blue text-dark-two lg:opacity-80 lg:transition-opacity lg:duration-300 lg:hover:opacity-100",
    loading: "bg-epic-blue-back border-epic-blue-back",
    loader: "#26bbff"
}

export const FORM_BUTTON_STYLES_DEL = {
    // base: "bg-epic-red-back border-epic-red-back text-epic-red",
    base: "border-dark-border text-dark-back",
    loading: "bg-epic-red-back border-epic-red-back",
    loader: "#ef4444"
}

// 8 seconds
export const RATE_LIMIT_DURATION = 8000; 

export const EMBLEM_FILTERS = [
    { name: "categories", options: EMBLEM_CATEGORIES },
    { name: "rarities", options: EMBLEM_RARITIES },
    // { name: "source", options: EMBLEM_TYPES }
]

export const TOURNAMENT_SEED_DATE = process.env.NODE_ENV === "development" ? "2025-06-22T10:37:00.000Z" : "2025-03-16T17:00:00.000Z";